// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VPB4i","newExpiryDate":"styles_newExpiryDate__NU4rs","footer":"styles_footer__1i2nV"};